import readers from "assets/images/news/readers-digest.webp";
import real from "assets/images/news/real-simple.webp";
import cnbc from "assets/images/news/cnbc.webp";
import brit from "assets/images/news/brit-co-seeklogo-com.webp";
import business from "assets/images/news/business-insider.webp";

export const CAROUSEL_INFOS = [
  {
    text: "Believe it or not, those unused gift cards might be worth more than you think.",
    by: "Readers Digest",
    image: readers
  },
  {
    text: "Whether you’re hoping to shop, store or redeem your gift cards, Raise makes it easy.",
    by: "Real Simple",
    image: real
  },
  {
    text: "It’s an easy way to save money at stores that you plan on shopping at anyway.",
    by: "CNBC",
    image: cnbc
  },
  {
    text: "The Raise app will help you stretch your dollar even further. Cha-ching!",
    by: "Brit & Co",
    image: brit
  },
  {
    text: "Raise is a smart way to save money where it matters.",
    by: "Business Insider",
    image: business
  }
];
